"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Project/App Name APIs
 * API documentation for the backend services of Project/App Name
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.instanceOfOfferIdDto = instanceOfOfferIdDto;
exports.OfferIdDtoFromJSON = OfferIdDtoFromJSON;
exports.OfferIdDtoFromJSONTyped = OfferIdDtoFromJSONTyped;
exports.OfferIdDtoToJSON = OfferIdDtoToJSON;
exports.OfferIdDtoToJSONTyped = OfferIdDtoToJSONTyped;
/**
 * Check if a given object implements the OfferIdDto interface.
 */
function instanceOfOfferIdDto(value) {
    if (!('id' in value) || value['id'] === undefined)
        return false;
    return true;
}
function OfferIdDtoFromJSON(json) {
    return OfferIdDtoFromJSONTyped(json, false);
}
function OfferIdDtoFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'id': json['id'],
        'status': json['status'] == null ? undefined : json['status'],
    };
}
function OfferIdDtoToJSON(json) {
    return OfferIdDtoToJSONTyped(json, false);
}
function OfferIdDtoToJSONTyped(value, ignoreDiscriminator) {
    if (ignoreDiscriminator === void 0) { ignoreDiscriminator = false; }
    if (value == null) {
        return value;
    }
    return {
        'id': value['id'],
        'status': value['status'],
    };
}
